import api from '@/utils/http'

/**
 功能：
 time: 2025/12/19 16:28
 **/
export function getProjectLogTreeList(project_id) {
    return api.post('/admin/projectLog/getTreeList', { project_id })
}
